import * as React from "react";
import { Box, Text } from "@chakra-ui/react";
import { AccordionItem, Form, TextInput } from "components";
import { getTimerValue, useCurrentCase } from "duck";
import { useUpdateComment, FormValues } from "./duck";

const TotalTimer: React.FC = () => {
  const defaultValues = useCurrentCase(({ data }) => ({
    notesTimer: data.client.patient.generalAssessment?.notesTimer || ""
  }));

  const totalTimeSec = useCurrentCase(({ data }) => {
    const chartings = data.client.patient.dentalChartings || [];
    return chartings.reduce(
      (acc, current) => acc + current.timerDurationSec,
      0
    );
  });

  const onChange = useUpdateComment();

  return (
    <AccordionItem title="Timer">
      <Box mb="24px">
        <Text fontWeight="medium">Total Time Spent</Text>
        <Text mt="8px">{getTimerValue(totalTimeSec)}</Text>
      </Box>

      <Form<FormValues> defaultValues={defaultValues}>
        <Form.Watcher onChange={onChange} defaultValues={defaultValues} />
        <TextInput
          label="Notes"
          placeholder="Enter Notes"
          type="text-area"
          name="notesTimer"
        />
      </Form>
    </AccordionItem>
  );
};

export default TotalTimer;
